export const setDefaultReducer = (type) => (payload) => ({ type, payload });